import axios from 'axios'

axios.defaults.withCredentials = true

export default {
    state : { 
        baseUrl:process.env.API_URL,
        activities:[]
    },
    getters : {
        activities:(state)=>{
            return state.activities
        }
    },
    mutations : { 
        activities(state,activities){
            state.activities = activities
        }
    },
    actions : { 
        deleteActivities({state,commit},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/deleteActivities`,form)
                .then(response => {
                    console.log("deleteActivities action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        /*
                        commit('organization',response.data.content.organization)
                        commit('user',response.data.user)
                        commit('users',response.data.users)
                        commit('organizationCustomFields',response.data.content.customFields)
                        resolve(response.data)
                        */
                       resolve(response.data)
                    }else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        },
        getActivities({state,commit},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getActivities`,form)
                .then(response => {
                    console.log("getActivities action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        commit('activities',response.data.content.activities)
                        commit('user',response.data.user)
                        commit('users',response.data.users)
                        resolve(response.data)
                    }else{
                        resolve(false)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
        }
    }
}